var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "enterprise-step1" },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            layout: "horizontal",
            model: _vm.form,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol,
          },
        },
        [
          _c(
            "a-form-model-item",
            { ref: "name", attrs: { label: "企业名称", prop: "companyName" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入企业名称" },
                model: {
                  value: _vm.form.companyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "companyName", $$v)
                  },
                  expression: "form.companyName",
                },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "联系人",
                        "label-col": { span: 8 },
                        wrapperCol: { span: 14 },
                        prop: "responsiblePerson",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "请输入联系人" },
                        model: {
                          value: _vm.form.responsiblePerson,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "responsiblePerson", $$v)
                          },
                          expression: "form.responsiblePerson",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        "label-col": { span: 6 },
                        wrapperCol: { span: 14 },
                        label: "联系电话",
                        prop: "mobile",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mobile", $$v)
                          },
                          expression: "form.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "联系邮箱", prop: "email" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入联系邮箱" },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "您的需求", prop: "description" } },
            [
              _c("a-textarea", {
                attrs: {
                  autosize: { minRows: 4, maxRows: 4 },
                  placeholder:
                    "请填写您的行业，需要在什么场景下使用什么功能，以便于我们的客服进行回访联系。",
                },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }